import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, of, forkJoin } from 'rxjs';
import { environment } from '@env/environment';
import { AuthenticationService } from '../app/auth/authentication.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  deviceInfo: any;
  deviceName: string;
  constructor(
    private http: HttpClient,
    private authenticationService: AuthenticationService,
    private deviceService: DeviceDetectorService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.getDevice();
  }
  getDevice() {
    //check if the app is running on which device
    this.deviceInfo = this.deviceService.getDeviceInfo();
    const isMobile = this.deviceService.isMobile(); // returns if the device is a mobile device (android / iPhone / windows-phone etc)
    const isTablet = this.deviceService.isTablet(); // returns if the device us a tablet (iPad etc)
    const isDesktopDevice = this.deviceService.isDesktop(); // returns if the app is running on a Desktop browser.
    if (isMobile == true) {
      this.deviceName = 'thumbnail';
    } else if (isTablet == true) {
      this.deviceName = 'medium';
    } else {
      this.deviceName = 'large';
    }
  }
  public getSearchInfo(
    selectedTerm: any,
    pageNumber?: number,
    catgoryType?: any,
    isLandNames?: any,
    attributes?: any
  ): Observable<any> {
    if (isLandNames) {
      if (isLandNames.length > 0) {
        if (isLandNames.indexOf(',') > -1) {
          var classificationArray = isLandNames.split(',');
          for (var i = 0; i < classificationArray.length; i++) {
            classificationArray[i] = `"${classificationArray[i]}"`;
          }
          isLandNames = classificationArray;
        } else {
          isLandNames = `"${isLandNames}"`;
        }
      }
    }
    if (attributes && attributes.length > 0) {
      attributes = attributes.toString().split(',');
      let Attr: any = [];
      Array.from(attributes).map((attr: any) => {
        Attr = [...Attr, attr];
        //attr = attr.replace('ENTITY', 'SVC');
        //Attr = [...Attr, attr];
        Array.from(Attr).reduce((prv: any, cur: any) => {
          prv = `${prv}|${cur}`;
          attributes = prv;
          return attributes;
        }, '');
        attributes = `"${attributes}"`.replace('|', '').slice(1, -1);
      });
    }
    if (!pageNumber) {
      pageNumber = 1;
    }
    let queryParams = '';
    if (catgoryType != undefined && catgoryType.length > 0) {
      queryParams = `&cats=${catgoryType}`;
    }
    if (isLandNames != undefined && isLandNames.length > 0) {
      queryParams += `&additionalQuery=islandName:(${isLandNames})`;
    }
    if (attributes != undefined && attributes.length > 0) {
      queryParams += `&att=${attributes}`;
    }
    return this.http.get(
      environment.apiSearchBaseURL +
        this.getLanguage() +
        `/listings?term="${selectedTerm}"` +
        '&pge=' +
        pageNumber +
        '&size=12' +
        '&out=json' +
        queryParams
    );
  }

  public getCategorySearch(selectedTerm: any): Observable<any> {
    return this.http.get(
      'http://api.stb.travel/api/v1/listings?term=' +
        selectedTerm +
        '&size=12' +
        '&fl=product_name,product_image,address,rate_from,rate_to,starrating,product_description' +
        '&facets=att,cla'
    );
  }

  getCountries() {
    const currentUser = this.authenticationService.currentUserValue;
    return this.http.get(environment.BaseURL + '/custom_countries_list?_format=json');
  }
  public getListType(selectedTerm: any): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('agent', this.deviceName);
    return this.http.get(environment.apiBaseURL + '/listingContents/' + selectedTerm, {
      headers: headers,
    });
  }
  public getWishList(): Observable<any> {
    //supraja
    const currentUser = this.authenticationService.currentUserValue;
    return this.http.get(environment.BaseURL + '/wishlist-list/?_format=json', {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + currentUser.access_token,
        'X-CSRF-Token': currentUser.csrf_token,
      }),
    });
  }
  public postWishList(item: any, catname: any, classification: any): Observable<any> {
    const currentUser = this.authenticationService.currentUserValue;
    let arr = [];
    if (classification && classification.length > 0) {
      classification.forEach((item: any) => {
        arr.push({ value: item });
      });
    } else {
      arr.push({ value: '' });
    }
    return this.http.post(
      environment.BaseURL + '/node/?_format=json',
      {
        type: [{ target_id: 'wish_list' }],
        title: [{ value: 'WishList' }],
        field_product_id: [{ value: item }],
        field_wishlist_category: [{ value: catname }],
        field_wishlist_classification: arr,
      },
      {
        headers: new HttpHeaders({
          Authorization: 'Bearer ' + currentUser.access_token,
          'X-CSRF-Token': currentUser.csrf_token,
        }),
      }
    );
  }

  public wishListDeatils(productItem: any): Observable<any> {
    if (productItem !== '') {
      let params = new HttpParams().set('additionalQuery', `productId:(${productItem})`);
      return this.http.get(environment.apiSearchBaseURL + this.getLanguage() + '/listings/', {
        params,
      });
    }
  }

  public removeWishListDeatils(nid: any): Observable<any> {
    const currentUser = this.authenticationService.currentUserValue;
    return this.http.delete(environment.adminBaseURL + `/node/${nid}`, {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + currentUser.access_token,
        'X-CSRF-Token': currentUser.csrf_token,
      }),
    });
  }

  public getCatInfo(selectedTerm: any): Observable<any> {
    return this.http.get(environment.apiSearchBaseURL + this.getLanguage() + '/classifications/' + selectedTerm);
  }

  getViewListingDetails(productId: number): Observable<any> {
    return this.http.get(environment.apiSearchBaseURL + this.getLanguage() + '/listingdetails/' + productId);
  }

  getViewListingDetailsEn(productId: number): Observable<any> {
    return this.http.get(environment.apiSearchBaseURL + 'ENGLISH' + '/listingdetails/' + productId);
  }

  getClassificationDetails(selClasName: string, pageNumber?: number) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    return this.http.get(
      environment.apiSearchBaseURL +
        this.getLanguage() +
        '/listings/' +
        '?cla=' +
        selClasName +
        '&pge=' +
        pageNumber +
        '&size=12' +
        '&out=json'
    );
  }
  getIsLandTypes(pageNumber?: number) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    return this.http.get(
      environment.apiSearchBaseURL +
        this.getLanguage() +
        '/listings/' +
        '?additionalQuery=islandType:(%22Inner%22)' +
        '&pge=' +
        pageNumber +
        '&size=12' +
        '&out=json'
    );
  }
  searchListingInfo(
    catgoryType?: any,
    classifications?: any,
    isLandNames?: any,
    isLandType?: string,
    attributes?: any,
    attr?: any,
    pageNumber?: number
  ): Observable<any> {
    if (attributes) {
      Array.from(attributes).reduce((prv: any, cur: any) => {
        prv = `${prv}|${cur}`;
        attributes = prv;
        return attributes;
      }, '');
      attributes = `"${attributes}"`.replace('|', '').slice(1, -1);
    }
    if (isLandNames) {
      Array.from(isLandNames).reduce((prv: any, cur: any) => {
        prv = `${prv},"${cur}"`;
        isLandNames = prv;
        return isLandNames;
      }, '');
      isLandNames = `"${isLandNames}"`.replace(',', '').slice(1, -1);
    }
    let queryParams = '';
    if (catgoryType != undefined && catgoryType.length > 0) {
      queryParams = `cats=${catgoryType}`;
    }
    if (classifications != undefined && classifications.length > 0) {
      queryParams += `&cla=${classifications}`;
    }
    if (isLandNames != undefined && isLandNames.length > 0) {
      queryParams += `&additionalQuery=islandName:(${isLandNames})`;
    }
    if (attributes != undefined && attributes.length > 0) {
      queryParams += `&att=${attributes}`;
    }
    if (attr != undefined && attr.length > 0) {
      queryParams = `&att=${attr}`;
    }
    if (isLandType != undefined && isLandType.length > 0) {
      queryParams += `&additionalQuery=islandType:(${isLandType})`;
    }
    if (!pageNumber) {
      pageNumber = 1;
    }
    return this.http.get(
      environment.apiSearchBaseURL +
        this.getLanguage() +
        '/listings?' +
        queryParams +
        '&pge=' +
        pageNumber +
        '&size=12' +
        '&fl=product_name,product_image,address,rate_from,rate_to,starrating,product_description'
    );
  }
  getPopularSearch(): Observable<any> {
    return this.http.get(environment.apiBaseURL + 'menu/popular-search-keywords/');
  }

  public getMapsListing(selectedTerm: any): Observable<any> {
    return this.http
      .get(
        environment.apiSearchBaseURL +
          this.getLanguage() +
          '/listings?cats=' +
          selectedTerm +
          '&pge=1' +
          '&size=500' +
          '&fl=product_name,product_description,product_image,product_classifications,address'
      )
      .pipe(
        map((data) => data),
        catchError((err) => of({ products: [] }))
      );
  }
  public getActvity(selectedTerm: any): Observable<any> {
    //alert(selectedTerm);
    return this.http.get(
      environment.apiSearchBaseURL +
        this.getLanguage() +
        '/listings?att=' +
        selectedTerm +
        '&pge=1' +
        '&size=12' +
        '&fl=product_name,product_image,address,rate_from,rate_to,starrating,product_description'
    );
  }
  //for workcation-DealsAndOffers
  workDealAndOffersSearchListings(attributes?: any, pageNumber?: number): Observable<any> {
    if (attributes) {
      attributes = attributes.toString().split(',');
      let Attr: any = [];
      Array.from(attributes).map((attr: any) => {
        Attr = [...Attr, attr];
        //attr = attr.replace('ENTITY', 'SVC');
        //Attr = [...Attr, attr];
        Array.from(Attr).reduce((prv: any, cur: any) => {
          prv = `${prv}|${cur}`;
          attributes = prv;
          return attributes;
        }, '');
        attributes = `"${attributes}"`.replace('|', '').slice(1, -1);
      });
    }
    let queryParams = '';
    if (attributes != undefined && attributes.length > 0) {
      queryParams += `&att=${attributes}`;
    }

    return this.http.get(
      environment.apiSearchBaseURL +
        this.getLanguage() +
        '/listings?' +
        queryParams +
        '&pge=' +
        pageNumber +
        '&size=12' +
        '&cats=ATTRACTION,HIRE,EVENT,TRANSPORT,RESTAURANT,INFO,GENSERVICE,TOUROPERATOR' +
        '&fl=product_name,product_category,product_image,address,rate_from,rate_to,starrating,product_description'
    );
  }

  //for all Category Pages
  planYourVisitSearchListing(
    catgoryType?: any,
    selectedClassificationName?: any,
    classifications?: any,
    isLandNames?: any,
    attributes?: any,
    // isLandType?: string,
    //attr?: any,
    pageNumber?: number,
    priceFilter?: any[],
    selectedTag?: any,
    countryName?: any,
    islandCatTypes?: any,
    attributesWithAnd?: any,
    sortBy?: string,
    sortOrder?: 'asc' | 'desc',
    advanceSearchFilter?: any
  ): Observable<any> {
    if (isLandNames) {
      if (isLandNames.length > 0) {
        if (isLandNames.indexOf(',') > -1) {
          var classificationArray = isLandNames.split(',');
          for (var i = 0; i < classificationArray.length; i++) {
            classificationArray[i] = `"${classificationArray[i]}"`;
          }
          isLandNames = classificationArray;
        } else {
          isLandNames = `"${isLandNames}"`;
        }
      }
    }
    let islandCatTypesWithName: any = [];
    if (islandCatTypes && islandCatTypes.length > 0) {
      islandCatTypes.forEach((item: any) => {
        islandCatTypesWithName.push('"' + item.id + '"');
      });
    }
    // if(attributes)
    // {
    // var attributesList = attributes.toString();
    // var attributes = attributesList.replace(/,/g ,'|');
    // }
    let attributesCombined = '';
    if (attributes) {
      attributes = attributes.toString().split(',');
      if (selectedTag) {
        attributes.push(selectedTag);
      }
      /*
      let Attr: any = [];
      Array.from(attributes).map((attr: any) => {
        //Attr = [...Attr, attr];
        attr = attr.replace('ENTITY', 'SVC');
        Attr = [...Attr, attr];
        Array.from(Attr).reduce((prv: any, cur: any) => {
          prv = `${prv}|${cur}`;
          attributes = prv;
          return attributes;
        }, '');
        attributes = `"${attributes}"`.replace('|', '').slice(1, -1);
      });*/
      attributes.forEach((item: any) => {
        // item = item.replace('ENTITY', 'SVC');
        if (attributesCombined !== '') {
          attributesCombined += '|' + item;
        } else {
          attributesCombined += item;
        }
      });
    }
    let queryParams = '';
    if (!sortOrder) {
      sortOrder = 'desc';
    }
    let order = '&order=product_update_date ' + sortOrder;
    if (catgoryType != undefined && catgoryType.length > 0) {
      queryParams = `cats=${catgoryType}`;
      if (catgoryType == 'EVENT') {
        queryParams = queryParams + '&additionalQuery=-allAttributes:(TAGDeals-Offers)';
        order = '&order=next_occurrence ' + sortOrder;
        if (sortOrder == 'asc') {
          order = '&order=next_occurrence desc';
        } else {
          order = '&order=next_occurrence asc';
        }
      }
    }
    //for walks and trails clear filter
    const currentUrl = this.router.url;
    if (currentUrl.includes('/experience/walksandtrails')) {
      let tagWalks = 'TAGWalks-Trails';
      let walkattributes = attributes[1];
      if (catgoryType === 'ATTRACTION' && walkattributes == undefined) {
        queryParams += `&att=${tagWalks}`;
      }
    }
    if (sortBy && catgoryType !== 'EVENT') {
      order = `&order=${sortBy} ${sortOrder || 'asc'}`;
    }
    if (attributes && attributes.indexOf('TAGDeals-Offers') > -1) {
      order = '&order=next_occurrence asc&cats=EVENT';
      //order = '&order=next_occurrence asc';
    }
    //Added for low to high filter
    if (sortBy === 'rate_from' && sortOrder === 'asc') {
      // Custom handling for rate_from ascending order
      order = ''; // Reset default order to handle it manually
      //let customOrder = '&order=asc'; // Custom ascending order
      // Add condition to include null or blank rate_from
      let rateFromOrder = `&order=product_update_date desc,rate_from asc`;
      order += `${rateFromOrder}`;
    }
    if (classifications != undefined && classifications.length > 0) {
      if (classifications === 'BEAUTY&HAIR') {
        classifications = classifications.replace('&', '');
      }
      queryParams += `&cla=${classifications}`;
    }
    if (selectedClassificationName != undefined && selectedClassificationName.length > 0) {
      queryParams += `&cla=${selectedClassificationName}`;
    }
    if (catgoryType == 'ACCOMM' && advanceSearchFilter && advanceSearchFilter.secretsRatings.length > 0) {
      let arr: any = [];
      advanceSearchFilter.secretsRatings.forEach((item: any) => {
        arr.push(`"${item.code}"`);
      });
      queryParams += `&additionalQuery=secrateRating:(${arr.join(',')})`;
    }
    if (catgoryType == 'ACCOMM' && advanceSearchFilter && advanceSearchFilter.starRatings.length > 0) {
      let arr: any = [];
      advanceSearchFilter.starRatings.forEach((item: any) => {
        arr.push(`${item.code}`);
      });
      queryParams += `&starrating=${arr.toString()}`;
    }
    if (catgoryType == 'TOUROPERATOR') {
      if (isLandNames != undefined && isLandNames.length > 0) {
        if (countryName == 'nonseychelles') {
          queryParams += `&additionalQuery=(islandName:(${isLandNames}) AND -allCountries:("seychelles"))`;
        } else {
          queryParams += `&additionalQuery=islandName:(${isLandNames})`;
        }
      } else if (countryName == 'nonseychelles') {
        if (countryName == 'russia') {
          countryName = 'russian federation';
        }
        queryParams += `&additionalQuery=-allCountries:("seychelles")`;
      }
      if (countryName != 'nonseychelles') {
        queryParams += `&cn=${countryName}`;
      }
    } else {
      if (isLandNames != undefined && isLandNames.length > 0) {
        queryParams += `&additionalQuery=islandName:(${isLandNames})`;
      }
      if (islandCatTypesWithName != undefined && islandCatTypesWithName.length > 0) {
        queryParams += `&additionalQuery=islandType:(${islandCatTypesWithName.toString()})`;
      }
    }
    if (attributesCombined != '' && attributesCombined.length > 0) {
      queryParams += `&att=${attributesCombined}`;
    }
    if (attributesWithAnd && attributesWithAnd != '') {
      queryParams += `&att=${attributesWithAnd}`;
    }
    if (!pageNumber) {
      pageNumber = 1;
    }

    let size = 12;
    //if (queryParams == 'cats=TOUR') {
    //  size = 100000000;
    //}
    let queryParamsWithPriceFilter = queryParams;

    if (priceFilter && priceFilter.length === 2) {
      queryParamsWithPriceFilter += `&minRate=${priceFilter[0]}&maxRate=${priceFilter[1]}`;

      const requestWithPriceFilter = this.http.get<any>(
        environment.apiSearchBaseURL +
          this.getLanguage() +
          '/listings?' +
          queryParamsWithPriceFilter +
          '&pge=' +
          pageNumber +
          '&size=' +
          size +
          '&fl=product_name,product_category,product_image,address,rate_from,rate_to,starrating,product_update_date,product_description,product_classifications,next_occurrence' +
          order
      );
      return requestWithPriceFilter;
      /*
       const requestWithoutPriceFilter = this.http.get<any>(
        environment.apiSearchBaseURL +
          this.getLanguage() +
          '/listings?' +
          queryParams +
          '&pge=' +
          pageNumber +
          '&size=' +
          size +
          '&fl=product_name,product_category,product_image,address,rate_from,rate_to,starrating,product_update_date,product_description,product_classifications,next_occurrence' +
          order
      );
      if (priceFilter && priceFilter.length === 2 && priceFilter[0] !== 0) {
        return requestWithPriceFilter;
      } else {
        return forkJoin([requestWithoutPriceFilter, requestWithPriceFilter]).pipe(
          switchMap(([withoutPriceResult, withPriceResult]) => {
            const filteredWithoutPriceData = withoutPriceResult.products.filter(
              (item: any) => !item.rateFrom && !item.rateTo
            );
            const mergedResults = {
              numberOfResults: filteredWithoutPriceData.length + withPriceResult.products.length,
              products: [...filteredWithoutPriceData, ...(withPriceResult?.products || [])],
            };
            mergedResults.products.sort((a, b) => a.productName.localeCompare(b.productName));
            return of(mergedResults);
          })
        );
      }*/
    } else {
      return this.http.get(
        environment.apiSearchBaseURL +
          this.getLanguage() +
          '/listings?' +
          queryParams +
          '&pge=' +
          pageNumber +
          '&size=' +
          size +
          '&fl=product_name,product_category,product_image,address,rate_from,rate_to,starrating,product_update_date,product_description,product_classifications,next_occurrence' +
          order
      );
    }
  }

  getCatandCla(productId: any) {
    const queryParams = `&additionalQuery=productId:(${productId})`;
    return this.http.get(
      environment.apiSearchBaseURL +
        this.getLanguage() +
        '/listings?' +
        queryParams +
        '&fl=product_name,product_category,product_classifications'
    );
  }

  findMinMaxService(
    catgoryType?: any,
    selectedClassificationName?: any,
    classifications?: any,
    isLandNames?: any,
    attributes?: any,
    // isLandType?: string,
    //attr?: any,
    pageNumber?: number,
    priceFilter?: any[],
    selectedTag?: any,
    countryName?: any,
    islandCatTypes?: any,
    attributesWithAnd?: any
  ): Observable<any> {
    if (isLandNames) {
      if (isLandNames.length > 0) {
        if (isLandNames.indexOf(',') > -1) {
          var classificationArray = isLandNames.split(',');
          for (var i = 0; i < classificationArray.length; i++) {
            classificationArray[i] = `"${classificationArray[i]}"`;
          }
          isLandNames = classificationArray;
        } else {
          isLandNames = `"${isLandNames}"`;
        }
      }
    }
    let islandCatTypesWithName: any = [];
    if (islandCatTypes && islandCatTypes.length > 0) {
      islandCatTypes.forEach((item: any) => {
        islandCatTypesWithName.push('"' + item.id + '"');
      });
    }
    // if(attributes)
    // {
    // var attributesList = attributes.toString();
    // var attributes = attributesList.replace(/,/g ,'|');
    // }
    let attributesCombined = '';
    if (attributes) {
      attributes = attributes.toString().split(',');
      if (selectedTag) {
        attributes.push(selectedTag);
      }
      /*
      let Attr: any = [];
      Array.from(attributes).map((attr: any) => {
        //Attr = [...Attr, attr];
        attr = attr.replace('ENTITY', 'SVC');
        Attr = [...Attr, attr];
        Array.from(Attr).reduce((prv: any, cur: any) => {
          prv = `${prv}|${cur}`;
          attributes = prv;
          return attributes;
        }, '');
        attributes = `"${attributes}"`.replace('|', '').slice(1, -1);
      });*/
      attributes.forEach((item: any) => {
        // item = item.replace('ENTITY', 'SVC');
        if (attributesCombined !== '') {
          attributesCombined += '|' + item;
        } else {
          attributesCombined += item;
        }
      });
    }
    let queryParams = '';
    let order = '&order=product_update_date desc';
    if (catgoryType != undefined && catgoryType.length > 0) {
      queryParams = `cats=${catgoryType}`;
      if (catgoryType == 'EVENT') {
        order = '&order=next_occurrence asc';
      }
    }
    if (classifications != undefined && classifications.length > 0) {
      if (classifications === 'BEAUTY&HAIR') {
        classifications = classifications.replace('&', '');
      }
      queryParams += `&cla=${classifications}`;
    }
    if (selectedClassificationName != undefined && selectedClassificationName.length > 0) {
      queryParams += `&cla=${selectedClassificationName}`;
    }
    if (catgoryType == 'TOUROPERATOR') {
      if (isLandNames != undefined && isLandNames.length > 0) {
        if (countryName == 'nonseychelles') {
          queryParams += `&additionalQuery=(islandName:(${isLandNames}) AND -allCountries:("seychelles"))`;
        } else {
          queryParams += `&additionalQuery=islandName:(${isLandNames})`;
        }
      } else if (countryName == 'nonseychelles') {
        queryParams += `&additionalQuery=-allCountries:("seychelles")`;
      }
      if (countryName != 'nonseychelles') {
        queryParams += `&cn=${countryName}`;
      }
    } else {
      if (isLandNames != undefined && isLandNames.length > 0) {
        queryParams += `&additionalQuery=islandName:(${isLandNames})`;
      }
      if (islandCatTypesWithName != undefined && islandCatTypesWithName.length > 0) {
        queryParams += `&additionalQuery=islandType:(${islandCatTypesWithName.toString()})`;
      }
    }
    if (attributesCombined != '' && attributesCombined.length > 0) {
      queryParams += `&att=${attributesCombined}`;
    }
    if (attributesWithAnd && attributesWithAnd != '') {
      queryParams += `&att=${attributesWithAnd}`;
    }
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (priceFilter?.length) {
      queryParams += `&minRate=${priceFilter[0]}&maxRate=${priceFilter[1]}`;
    }
    let size = 100000000;
    return this.http.get(
      environment.apiSearchBaseURL +
        this.getLanguage() +
        '/listings?' +
        queryParams +
        '&pge=' +
        pageNumber +
        '&size=' +
        size +
        '&fl=product_name,rate_from,rate_to'
    );
  }
  islandTypes(catgoryType?: any, classifications?: any, terms?: any) {
    let queryParams = '';
    if (catgoryType != undefined && catgoryType.length > 0) {
      queryParams = `&cats=${catgoryType}`;
    }
    if (classifications != undefined && classifications.length > 0) {
      queryParams += `&cla=${classifications}`;
    }
    if (terms != undefined && terms.length > 0) {
      queryParams += `&term=${terms}`;
    }
    return this.http.get(
      environment.apiSearchBaseURL +
        this.getLanguage() +
        '/listings/' +
        '?rows=0&fl=islandName&wt=json&indent=true&json.facet={ search: { type : terms, field : islandName }}' +
        queryParams
    );
  }
  ameniesTypes(catgoryType?: any, classifications?: any, terms?: any) {
    let queryParams = '';
    if (catgoryType != undefined && catgoryType.length > 0) {
      queryParams = `&cats=${catgoryType}`;
    }
    if (classifications != undefined && classifications.length > 0) {
      queryParams += `&cla=${classifications}`;
    }
    if (terms != undefined && terms.length > 0) {
      queryParams += `&term=${terms}`;
    }
    return this.http.get(
      environment.apiSearchBaseURL +
        this.getLanguage() +
        '/listings/' +
        '?rows=0&fl=islandName&wt=json&indent=true&json.facet={ search: { type : terms, field : allAttributes }}' +
        queryParams
    );
  }
  public getSocialIcons(): Observable<any> {
    return this.http.get(environment.apiBaseURL + '/social-media-menu');
  }
  public getAttributes() {
    return this.http
      .get<any>(environment.apiSearchBaseURL + this.getLanguage() + '/attributes')
      .toPromise()
      .then((data) => {
        return data;
      });
  }

  public getLanguage() {
    var language = localStorage.getItem('language');
    if (language == 'EN') {
      language = 'ENGLISH';
    }
    if (language == 'FR') {
      language = 'FRENCH';
    }
    if (language == 'DE') {
      language = 'GERMAN';
    }
    if (language == 'IT') {
      language = 'ITALIAN';
    }
    if (language == 'ES') {
      language = 'SPANISH';
    }
    if (language == 'RU') {
      language = 'RUSSIAN';
    }
    if (language == 'ZH') {
      language = 'CHINESE';
    }
    if (language == 'PT') {
      language = 'PORTUGUESE';
    }
    if (language == 'HI') {
      language = 'HINDI';
    }
    if (language == 'JA') {
      language = 'JAPANESE';
    }
    if (language == 'AR') {
      language = 'ARABIC';
    }
    return language;
  }
}
